@if (article) {
    <div id="container">
        <blog-hero-picture
            class="hero-picture"
            [article]="article"
            [showAuthor]="true"
            [labels]="(labels | async) ?? undefined"
            [breakpoint]="breakpoint"
            [breadcrumbs]="breadcrumbs"
            (authorClicked)="authorClicked($event)"
            (tagClicked)="tagClicked($event)"
        ></blog-hero-picture>
        @if (!article.content.length) {
            <blog-fs-add-section
                style="position: absolute; left: 50%; transform: translateX(-50%); z-index: 300"
                [previewId]="article.preview_id"
                [label]="(labels | async)?.create_section"
            ></blog-fs-add-section>
        }
        <blog-content
            [contents]="article.content"
            [margin]="article.margin ?? []"
            [breakpoint]="breakpoint"
        ></blog-content>
        <!-- related posts -->
        @if (relatedPosts.length) {
            <blog-connected-article-list
                [breakpoint]="breakpoint"
                [articles]="relatedPosts"
                [header]="(labels | async)?.related_articles"
                [imgSrc]="'assets/images/round_icons/all_articles.svg'"
            ></blog-connected-article-list>
        }
    </div>
}
